/* eslint react/no-children-prop: 0 */
import React, { useEffect } from 'react'
import { includes } from 'libraries/lodash'
import { useDispatch, useSelector } from 'react-redux'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { observePageState, updatePageState } from 'libraries/front-end-core/services/PageStateService'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { requestFolders, moveArchiveCategoryToEnd } from 'services/LegislationService'
import selectLegislationFoldersMap from 'redux/selectors/selectLegislationFoldersMap'
import { setLegislationFolders } from 'redux/actions'
import Error from 'components/shared/Error'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Heading from './Heading'
import { selectSelectedAols } from 'redux/selectors/selectSelectedAols'

export default ({ query }) => {
  const folders = useObservable(
    requestFolders(),
    RESPONSE_PENDING
  )

  return (
    <ResponseConsumer
      content={() => <LegCategoriesMenu query={query} folders={folders} />}
      response={folders}
      skeleton='legislation-accordion'
    />
  )
}

const LegCategoriesMenu = ({ folders, query: { name: folderName } }) => {
  const expandedSection = useObservable(observePageState('expandedSection'))
  const foldersMap = useSelector(selectLegislationFoldersMap)
  const dispatch = useDispatch()
  const selectedAols = useSelector(selectSelectedAols)

  useEffect(() => {
    dispatch(
      setLegislationFolders(folders)
    )
  }, [folders])

  if (!foldersMap) return null

  let categories = foldersMap.get(folderName)
  if (!categories) {
    return <Error title={`No categories found for "${folderName}"`} />
  }

  categories = moveArchiveCategoryToEnd(categories)

  const toggleExpandedSection = (id) => {
    updatePageState({ expandedSection: expandedSection !== id ? id : null })
  }

  return (
    <div className='bg-page-background w-100'>
      <div className='layout-width-constraint'>
        <section className='bg-white pt7 pb6'>
          <span className='f3 b pl6'>{folderName}</span>
        </section>
        {!categories
          ? <Error title='No content' />
          : (
            <ul className='bg-white list-reset pa0 mt0'>
              {categories.reduce(
                (acc, category) => {
                  const legislation = selectedAols.length > 0
                    ? category.legislation.filter(legislationItem =>
                      selectedAols.some(aol => includes(legislationItem.areasOfLaw, aol))
                    )
                    : category.legislation
                  const id = `${category.name}-${legislation.map(l => l.id).join('-')}`

                  if (legislation.length > 0) {
                    return [
                      ...acc,
                      (
                        <Heading
                          key={id}
                          id={id}
                          name={category.name}
                          children={legislation}
                          sectionId={folderName}
                          expanded={expandedSection === category.name}
                          toggleExpandedSection={() => toggleExpandedSection(category.name)}
                        />
                      )

                    ]
                  }

                  return acc
                }, []
              )}
            </ul>
            )}
      </div>
    </div>
  )
}
